import BasePagination from '@/mixins/base-pagination.js'
export default {
  mixins: [BasePagination],
  data() {
    return {
      loading: false,
      tableData: [],
    }
  },
  methods: {
    setData(res) {
      this.tableData = res.body.data
      if (this.usePage) {
        this.page.pageTotal = res.body.count
        this.page.pageSize = res.body.pageSize
        this.page.curPage = res.body.curPage
      }
    },
    reload({ isReset = false } = {}) {
      this.$refs.header.query({ isReset })
    },
  },
}
